import React from 'react'

const NeutralButton = ({ label, icon: Icon, onClick, disabled = false, textColor = '', className = '', ...props }) => {
    return (
        <button
            onClick={onClick}
            className={`min-w-[120px] flex items-center justify-center gap-2 px-4 py-2 rounded-lg font-medium transition-all duration-200 bg-gray-50 hover:bg-gray-100 text-sm

        ${disabled
                    ? 'bg-gray-200 text-gray-700 hover:bg-gray-300 cursor-not-allowed'
                    : `bg-gray-200 text-gray-700 text-${textColor}-500`
                }
        ${className}`}
            {...props}
        >
            {Icon && <Icon className="w-5 h-5" />}
            {label}
        </button>   
    )
}

export default NeutralButton